package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Vertical icon-with-label action used on the business detail header (Call / Directions / Chat / Website).
 * [enabled] false dims the action and disables the tap (e.g. a business with no phone or website).
 */
@Composable
fun ActionButton(
    iconName: String,
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
) {
    val container = if (enabled) AppTheme.colors.primaryContainer else AppTheme.colors.surfaceContainerHigh
    val icon = if (enabled) AppTheme.colors.onPrimary else AppTheme.colors.onSurfaceVariant
    val labelColor = if (enabled) AppTheme.colors.onSurface else AppTheme.colors.onSurfaceVariant
    Column(
        modifier = modifier.clickable(enabled = enabled, onClick = onClick),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
    ) {
        Box(
            modifier = Modifier
                .size(AppTheme.sizes.minTouchTarget)
                .background(container, AppTheme.shapes.pill),
            contentAlignment = Alignment.Center,
        ) {
            AppIcon(name = iconName, size = AppTheme.sizes.iconMd, tint = icon)
        }
        Text(text = label, style = AppTheme.typography.labelSm, color = labelColor)
    }
}
